<template>
<div class="modal is-active">
  <div class="modal-background"></div>
  <div v-if="allCategories" class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title is-flex">{{ $t('chooseCategory') }}</p>
    </header>
    <section class="modal-card-body footerless" v-bind:style="{'min-height' : modalBodyHeight + 'px'}">
      <span class="modal-text"> {{subText}} </span>
      <div ref="categoryInput" class="cat-select" >
        <category-selector v-model="selectedCategories" :includeSubCategories="true" :isModal="true" @calculateBodyHeight="calculateBodyHeight"></category-selector>
      </div>
    </section>
    <footer class="modal-card-foot">
      <button @click="success" class="button success-button is-primary" :disabled="disabled || saving">
        <span v-if="!saving">{{ $t('projectPage.post') }}</span>
        <span v-if="saving">{{ $t("projectPage.saving") }}</span>
      </button>
      <button @click="cancel" class="button cancel-button">{{ $t('cancel') }}</button>
    </footer>
  </div>
</div>
</template>

<script>
import componentState from '@/mixins/component-state'
import CategorySelector from '@/components/Inputs/CategorySelector'

export default {
  props: ['successText', 'cancelText', 'saving', 'subText'],
  components: {
    CategorySelector
  },
  mixins: [componentState],
  data: function () {
    return {
      seenModal: true,
      inputValue: '',
      selectedCategories: [],
      customTag: '',
      modalBodyHeight: 100
    }
  },
  created: function () {
    this.$store.dispatch('getCategories', this.$route.path.substring(1))
    this._callback('lockScrolling')
  },
  mounted: function () {
    if (this.filledInput) {
      this.inputValue = this.filledInput
      document.getElementById('inputField').setAttribute('readonly', true)
    }
    this.calculateBodyHeight()
  },
  computed: {
    disabled: function () {
      return !this.selectedCategories.length
    },
    allCategories: function () {
      return this.$store.getters.categoriesLoaded ? this.$store.getters.sortedProjectCategories() : []
    }
  },
  methods: {
    success: function () {
      this.$emit('modalSuccess', this.selectedCategories)
      this._callback('unlockScrolling')
    },
    calculateBodyHeight: function () {
      this.modalBodyHeight = this.$refs.categoryInput.offsetHeight + 140
    },
    cancel: function () {
      this.$emit('modalCancel')
      this._callback('unlockScrolling')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';

  .modal-card {
    overflow: visible;
  }

  .close-button {
    position: absolute;
    right: 1.5rem;
    top: 1.5rem;
  }
  .modal-card-body {
    padding: 1.5rem 3rem 0.5rem;
    overflow: visible;
    @include mobile {
      padding: 1rem;
    }
  }
  .cat-select {
    position: absolute;
    z-index: 10;
    padding-top: 10px;
    padding-right: 10px;
  }

  .modal-card-head {
    align-items: center;
    @include mobile {
      flex-direction: column;
      align-items: flex-start;
    }
    p {
      height: 55px;
      align-items: center;
    }
    .selected-tags {
      padding: 0 2rem;
      align-items: center;
      flex-wrap: wrap;
    }
  }

  .selected-tags {
    width: 100%;
  }

  .modal-card {
    width: 750px;
    @include mobile {
      width: 95%;
    }
  }

  .modal-card-foot {
    padding: 1rem 3rem;

    div.has-text-danger {
      flex-grow: 1;
    }
  }

  .btn-flex-end {
    justify-content: flex-end;
  }

  .btn-center {
    justify-content: center;
  }

  .tag-cloud {
    padding: 2rem 0;
    @include mobile {
      padding: 1rem 0;
    }
  }

  .tags-wrapper{
    justify-content: flex-start;
    flex-wrap: wrap;
    .a-tag {
      display: inline-block;
      height: inherit;
    }
    .tag {
      margin-right: 0.3rem;
      font-size: 0.6rem;
      color: white;
      border-radius: 0;
      margin-bottom: 0.3rem;
    }
  }
  .tags-wrapper-cloud {
    justify-content: center;
    .tag {
      font-size: 0.9rem;
      margin-right: 0.75rem;
      margin-bottom: 0.75rem;
      padding: 0 1.5rem;
      @include mobile {
        font-size: 0.8rem;
        padding: 0 1rem;
        margin-right: 0.5rem;
        margin-bottom: 0.5rem;
      }
    }
    .close-btn {
      margin-left: 0.25rem;
    }
  }
  .tags-wrapper-header {
    align-items: center;
    justify-content: flex-start;
    margin-left: 1.0rem;
    .tag {
      margin: 0.25rem;
    }
    @include mobile {
      margin-left: 0;
    }
  }

  .board-type {
    font-size: 0.6rem;
    border: 1px solid $grey;
    text-transform: uppercase;
    padding: 0.1rem 0.35rem;
    margin-right: 0.25rem;
    margin-bottom: 0.3rem;
  }

  .type-selector {
    margin-bottom: 0.5rem;
  }
  .type-description {
    display: block;
    font-size: 0.8rem;
    color: $grey-light;
  }

</style>
